'use client'

import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { useTRPC } from '@/app/api/trpc/config'
import { buildNewsletterSignupEmail } from '@/frontend/_marketing/email-templates'
import { H3 } from '@/frontend/design-system/_marketing/typography/Heading'
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph'
import { Button } from '@/frontend/design-system/actions/Button'
import { showErrorToastWithAlgoPhoneNumber } from '@/frontend/design-system/feedback/Toaster/ToasterError'
import { Input } from '@/frontend/design-system/forms/Input'

type NewsletterForm = {
  email: string
}

export function Newsletter() {
  const trpc = useTRPC()
  const sendEmailMutation = useMutation(trpc.notifications.sendEmails.mutationOptions())
  const { register, handleSubmit, reset } = useForm<NewsletterForm>()

  const onSubmit = async (data: NewsletterForm) => {
    try {
      await sendEmailMutation.mutateAsync({
        emailData: {
          ...buildNewsletterSignupEmail(data.email),
          correspondents: {
            senderEmail: data.email
          }
        }
      })
      reset()
      toast.success('Udało się!', {
        description: 'Dziękujemy za zapisanie się do naszego newslettera!'
      })
    } catch {
      showErrorToastWithAlgoPhoneNumber()
    }
  }

  return (
    <div className='space-y-4'>
      <H3>Zapisz się do naszego newslettera</H3>
      <P3>Otrzymuj promocje i specjalne materiały.</P3>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className='flex flex-col items-center gap-4 lg:flex-row'
      >
        <Input
          placeholder='Email'
          type='email'
          {...register('email', { required: true })}
          className='h-full'
        />
        <Button marketing type='submit' className='text-nowrap lg:h-full lg:text-sm'>
          Zapisz się
        </Button>
      </form>
    </div>
  )
}
